export enum GeneralAttributes {
    ari = "Ari Armaturen",
    netilion = "Endress + Hauser",
    krohne = "Krohne",
    errorWrongCredentials = "Es konnte leider kein Zugang mit dem entsprechenden Benutzernamen und Passwort gefunden werden.",
    errorUnexpected = "Etwas ist schief gegangen!",
    signIn = "ANMELDEN"
}